const CHECKOUT_RESUME_KEY = "guestCheckoutResume:v1";
export const MAX_CHECKOUT_RESUME_AGE_MS = 15 * 60 * 1000;

const hasSessionStorage = () => typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";

const clearCorruptState = () => {
  if (!hasSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(CHECKOUT_RESUME_KEY);
};

export const getCheckoutResumeState = () => {
  if (!hasSessionStorage()) {
    return null;
  }

  try {
    const raw = window.sessionStorage.getItem(CHECKOUT_RESUME_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    const hasValidStatus = parsed?.status === "pending" || parsed?.status === "processing";
    const hasValidCreatedAt = typeof parsed?.createdAt === "number";
    const hasValidReturnTo = typeof parsed?.returnTo === "string" && parsed.returnTo.length > 0;

    if (!hasValidStatus || !hasValidCreatedAt || !hasValidReturnTo) {
      clearCorruptState();
      return null;
    }

    if (Date.now() - parsed.createdAt > MAX_CHECKOUT_RESUME_AGE_MS) {
      clearCorruptState();
      return null;
    }

    return parsed;
  } catch (error) {
    clearCorruptState();
    return null;
  }
};

export const setCheckoutResumePending = (returnTo = "/order") => {
  if (!hasSessionStorage()) {
    return;
  }

  const nextState = {
    status: "pending",
    createdAt: Date.now(),
    returnTo,
  };

  window.sessionStorage.setItem(CHECKOUT_RESUME_KEY, JSON.stringify(nextState));
};

export const markCheckoutResumeProcessing = () => {
  if (!hasSessionStorage()) {
    return;
  }

  const current = getCheckoutResumeState();
  const nextState = {
    status: "processing",
    createdAt: current?.createdAt ?? Date.now(),
    returnTo: current?.returnTo ?? "/order",
  };

  window.sessionStorage.setItem(CHECKOUT_RESUME_KEY, JSON.stringify(nextState));
};

export const clearCheckoutResumeState = () => {
  if (!hasSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(CHECKOUT_RESUME_KEY);
};
